import ViewPurchaseReturn from "../../../../components/@documents/purchase_returns/ViewPurchaseReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseReturnViewPage() {

    return (
        <ViewPurchaseReturn 
            routeType={routeTypes.workstation}
        />
    )
}